import { setting } from "shared/types/Report";
import { SettingCard, SettingTitle, SettingGroupWrap, SettingGroup, SettingLabelWrap, SettingLabel, SettingCheck, SettingSelect } from "../homeworkUi";

interface SentenceSettingProps{
    viewOptions:(name:string, max:number, unit:string) => any[],
    onSettingChangeHandler: <T>(type: keyof setting, name: string, value:T) => void,
    setting:setting
}

const SentenceSetting = ({viewOptions, onSettingChangeHandler, setting}:SentenceSettingProps) => {
    const TYPE = "sentence";

    return(
        <SettingCard>
            <SettingTitle>문장 학습</SettingTitle>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="listen" name="listening" checked={setting.sentence.listening} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, e.target.checked)}/>
                        <SettingLabel htmlFor="listen">문장 듣기</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="sentence_repeat" value={setting.sentence.sentence_repeat} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))} disabled={!setting.sentence.listening}>
                        {viewOptions("", 4, "번")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="record" name="record" checked={setting.sentence.record} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, e.target.checked)}/>
                        <SettingLabel htmlFor="record">문장 녹음</SettingLabel>
                    </SettingLabelWrap>
                </SettingGroup>
            </SettingGroupWrap>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabel>퀴즈 커트라인 (오답)</SettingLabel>
                    <SettingSelect name="cutline" value={setting.sentence.cutline} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))}>
                        {viewOptions("", 4, "개")}
                    </SettingSelect>
                </SettingGroup>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="difficulty" name="order" checked={setting.sentence.order} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, e.target.checked)}/>
                        <SettingLabel htmlFor="difficulty">어순 퀴즈 빈칸(높을수록 어려움)</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="blank" value={setting.sentence.blank} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))} disabled={!setting.sentence.order}>
                        {viewOptions("빈칸", 9, "%")}
                    </SettingSelect>
                    <SettingSelect name="pass" value={setting.sentence.pass} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))} disabled={!setting.sentence.order}>
                        {viewOptions("통과율", 10, "%")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
        </SettingCard>
    )
}

export default SentenceSetting;
